<template>
    <div>{{ row.ticket_top / 100 | money }}</div>
</template>

<script>
export default {
    props: ['row'],
};
</script>
